import React from 'react';
import { Box, Typography, Chip, Stack, Avatar } from '@mui/material';
import { WhatsAppConnection } from './whatsappTypes';
import { PhoneCall, Calendar, Check } from 'lucide-react';
import { formatDate } from '../../utilities/date';

interface ConnectionStatusProps {
    connection: WhatsAppConnection;
}

const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ connection }) => {
    if (!connection.isConnected) {
        return (
            <Box >
                <Chip
                    label="Desconectado"
                    color="error"
                    variant="outlined"
                    sx={{ px: 1, fontWeight: 500 }}
                />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                p: 2,
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'success.light',
                backgroundColor: 'success.lighter',
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: -15,
                    right: -15,
                    width: 80,
                    height: 80,
                    borderRadius: '50%',
                    backgroundColor: 'success.light',
                    opacity: 0.2
                }}
            />

            <Stack direction="row" spacing={2} alignItems="center">
                <Avatar
                    sx={{
                        backgroundColor: '#25D366',
                        width: 56,
                        height: 56
                    }}
                >
                    <Check />
                </Avatar>

                <Box sx={{ flexGrow: 1 }}>
                    <Chip
                        label="Conectado"
                        color="success"
                        sx={{ mb: 1, fontWeight: 500 }}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 500 }}>
                        {connection.name || 'WhatsApp Conectado'}
                    </Typography>

                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 0.5, sm: 2 }}
                        sx={{ mt: 1 }}
                    >
                        {connection.phone_number && (
                            <Stack direction="row" spacing={0.5} alignItems="center">
                                <PhoneCall size={16} />
                                <Typography variant="body2" color="text.secondary">
                                    {connection.phone_number}
                                </Typography>
                            </Stack>
                        )}

                        {connection.connected_at && (
                            <Stack direction="row" spacing={0.5} alignItems="center">
                                <Calendar size={16} />
                                <Typography variant="body2" color="text.secondary">
                                    Conectado desde {formatDate(connection.connected_at, "brH")}
                                </Typography>
                            </Stack>
                        )}
                    </Stack>
                </Box>
            </Stack>
        </Box>
    );
};

export default ConnectionStatus;